import dayjs from "dayjs";
import { FranchiseOpportunity } from "../../../types/Location";

export interface MultiRestaurantSelectionProp {
  franchiseOpportunity: FranchiseOpportunity;
}

function MultiRestaurantSelection({
  franchiseOpportunity,
}: MultiRestaurantSelectionProp) {
  const {
    recruitPhase1Date,
    recruitPhase2Date,
    recruitPhase3Date,
    recruitPhase4Date,
    recruitPhase5Date,
  } = franchiseOpportunity;

  if (new Date(recruitPhase4Date).toString() === "Invalid Date") {
    return (
      <svg
        width="363"
        height="524"
        viewBox="0 0 363 514"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: "block", margin: "auto" }}
      >
        <text
          fill="#004F71"
          xmlSpace="preserve"
          style={{ whiteSpace: "pre" }}
          fontFamily="Apercu"
          fontSize="20"
          fontWeight="bold"
          letterSpacing="0em"
        >
          <tspan x="104.925" y="21.76">
            Multi-Restaurant&#10;
          </tspan>
          <tspan x="74.675" y="53.76">
            Activation and Timeline
          </tspan>
        </text>
        <text
          fill="#5B6770"
          xmlSpace="preserve"
          style={{ whiteSpace: "pre" }}
          fontFamily="Apercu"
          fontSize="14"
          fontWeight="bold"
          letterSpacing="0em"
        >
          <tspan x="45.5195" y="84.032">
            FOR GRAND OPENING RESTAURANTS ONLY&#10;
          </tspan>
          <tspan x="146.801" y="108.032">
            ~13 WEEKS
          </tspan>
        </text>
        <line
          x1="104.5"
          y1="182"
          x2="104.5"
          y2="428"
          stroke="#DD0031"
          strokeWidth="4"
          strokeLinecap="round"
          strokeDasharray="0.25 10"
        />
        <text
          fill="#5B6770"
          xmlSpace="preserve"
          style={{ whiteSpace: "pre" }}
          fontFamily="Apercu"
          fontSize="14"
          fontWeight="bold"
          letterSpacing="0em"
        >
          <tspan x="135.5" y="482.032">
            IF NOT MULTI-RESTAURANT FIRST,{" "}
          </tspan>
          <tspan x="135.5" y="506.032">
            THEN ACTIVATE FOR STANDARD{" "}
          </tspan>
          <tspan x="135.5" y="530.032">
            SELECTION
          </tspan>
        </text>
        <rect x="82" y="428" width="44" height="44" rx="22" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M 94.1266 450 C 94.1266 444.547 98.5471 440.127 104 440.127 C 109.453 440.127 113.873 444.547 113.873 450 C 113.873 455.453 109.453 459.873 104 459.873 C 98.5471 459.873 94.1266 455.453 94.1266 450 Z M 104 438 C 97.3726 438 92 443.373 92 450 C 92 456.627 97.3726 462 104 462 C 110.627 462 116 456.627 116 450 C 116 443.373 110.627 438 104 438 Z M 108.397 448.321 C 108.813 447.906 108.813 447.233 108.397 446.818 C 107.982 446.403 107.309 446.403 106.894 446.818 L 102.785 450.927 L 101.106 449.248 C 100.691 448.833 100.018 448.833 99.6026 449.248 C 99.1873 449.663 99.1873 450.337 99.6026 450.752 L 102.033 453.182 C 102.448 453.597 103.121 453.597 103.537 453.182 L 108.397 448.321 Z"
          fill="#DD0031"
        />
        <rect
          x="82"
          y="428"
          width="44"
          height="44"
          rx="22"
          stroke="#DD0031"
          strokeWidth="4"
        />
        <text
          fill="#DD0031"
          xmlSpace="preserve"
          style={{ whiteSpace: "pre" }}
          fontFamily="Apercu"
          fontSize="20"
          fontWeight="bold"
          letterSpacing="0em"
        >
          <tspan x="136.111" y="455.76">
            Select
          </tspan>
        </text>
        <text
          fill="#DD0031"
          xmlSpace="preserve"
          style={{ whiteSpace: "pre" }}
          fontFamily="Apercu"
          fontSize="20"
          fontWeight="bold"
          letterSpacing="0em"
        />
        <rect x="82" y="318" width="44" height="44" rx="22" fill="white" />
        <ellipse
          cx="99.7268"
          cy="331.79"
          rx="0.455704"
          ry="0.450937"
          fill="#DD0031"
        />
        <ellipse
          cx="102.217"
          cy="331.79"
          rx="0.455704"
          ry="0.450937"
          fill="#DD0031"
        />
        <path
          d="M105.043 332.241C105.228 332.242 105.395 332.133 105.467 331.965C105.539 331.796 105.501 331.602 105.371 331.472C105.241 331.342 105.044 331.303 104.873 331.373C104.703 331.442 104.591 331.607 104.591 331.79C104.591 332.037 104.793 332.239 105.043 332.241Z"
          fill="#DD0031"
        />
        <path
          d="M107.533 332.241C107.718 332.242 107.885 332.133 107.957 331.965C108.028 331.796 107.99 331.602 107.86 331.472C107.73 331.342 107.534 331.303 107.363 331.373C107.192 331.442 107.081 331.607 107.081 331.79C107.081 332.037 107.283 332.239 107.533 332.241Z"
          fill="#DD0031"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M114.347 334.137C114.841 334.193 115.293 334.443 115.599 334.833C116.238 335.635 116.099 336.799 115.287 337.432L113.991 338.455L114.732 339.379C114.917 339.617 114.874 339.958 114.635 340.145L110.931 343.052V350.117C110.931 350.42 110.682 350.667 110.375 350.667H97.2224C96.9154 350.667 96.6666 350.42 96.6666 350.117V329.883C96.6666 329.58 96.9154 329.333 97.2224 329.333H110.375C110.677 329.339 110.919 329.584 110.919 329.883V336.149L112.968 334.536C113.355 334.225 113.852 334.081 114.347 334.137ZM97.9856 330.433H97.7781V333.043H98.0041C98.0558 332.851 98.2322 332.716 98.4339 332.716C98.6356 332.716 98.812 332.851 98.8637 333.043H100.494C100.545 332.851 100.722 332.716 100.924 332.716C101.125 332.716 101.302 332.851 101.353 333.043H103.324C103.373 332.849 103.55 332.712 103.752 332.712C103.955 332.712 104.131 332.849 104.18 333.043H105.81C105.862 332.851 106.038 332.716 106.24 332.716C106.442 332.716 106.618 332.851 106.67 333.043H108.656C108.707 332.851 108.884 332.716 109.085 332.716C109.287 332.716 109.464 332.851 109.515 333.043H109.856V330.433H109.534C109.535 330.443 109.535 330.453 109.534 330.463C109.549 330.633 109.466 330.797 109.32 330.887C109.173 330.977 108.987 330.977 108.84 330.887C108.693 330.797 108.611 330.633 108.626 330.463V330.433H106.725C106.727 330.443 106.727 330.453 106.725 330.463C106.741 330.633 106.658 330.797 106.511 330.887C106.364 330.977 106.179 330.977 106.032 330.887C105.885 330.797 105.802 330.633 105.818 330.463V330.433H104.228V330.463C104.244 330.633 104.161 330.797 104.014 330.887C103.867 330.977 103.682 330.977 103.535 330.887C103.388 330.797 103.305 330.633 103.321 330.463V330.433H101.39V330.463C101.406 330.633 101.323 330.797 101.176 330.887C101.029 330.977 100.844 330.977 100.697 330.887C100.55 330.797 100.467 330.633 100.483 330.463C100.481 330.453 100.481 330.443 100.483 330.433H98.8896V330.463C98.8604 330.688 98.6668 330.856 98.4376 330.856C98.2083 330.856 98.0148 330.688 97.9856 330.463V330.433ZM109.808 349.567H97.7781V334.169H109.808V337.032L102.643 342.667C102.572 342.723 102.517 342.795 102.48 342.876L101.583 344.889C101.53 345.018 101.53 345.163 101.583 345.292L101.001 345.75C100.761 345.94 100.721 346.286 100.912 346.524C101.104 346.762 101.454 346.801 101.694 346.612L102.268 346.157C102.36 346.22 102.468 346.255 102.58 346.256C102.631 346.256 102.682 346.249 102.732 346.234L104.788 345.666C104.859 345.646 104.926 345.612 104.984 345.567L109.801 341.758L109.808 349.567ZM104.51 344.526L109.808 340.354L110.919 339.478L112.45 338.271L111.52 337.084L110.919 337.553L109.808 338.429L103.536 343.371L104.51 344.526ZM110.919 341.648V340.882L113.142 339.14L113.513 339.621L110.919 341.648ZM114.606 336.574C114.766 336.451 114.867 336.268 114.887 336.068H114.906C114.961 335.76 114.811 335.451 114.535 335.3C114.258 335.148 113.914 335.187 113.68 335.397L112.409 336.398L113.339 337.586L114.606 336.574Z"
          fill="#DD0031"
        />
        <rect
          x="82"
          y="318"
          width="44"
          height="44"
          rx="22"
          stroke="#DD0031"
          strokeWidth="4"
        />
        <text
          fill="#DD0031"
          xmlSpace="preserve"
          style={{ whiteSpace: "pre" }}
          fontFamily="Apercu"
          fontSize="20"
          fontWeight="bold"
          letterSpacing="0em"
        >
          <tspan x="136.404" y="335.76">
            Application&#10;
          </tspan>
          <tspan x="136.404" y="367.76">
            Review
          </tspan>
        </text>
        <rect x="82" y="226" width="44" height="44" rx="22" fill="white" />
        <ellipse
          cx="98.5937"
          cy="251.681"
          rx="0.488394"
          ry="0.495473"
          fill="#DD0031"
        />
        <ellipse
          cx="101.399"
          cy="251.681"
          rx="0.488394"
          ry="0.495473"
          fill="#DD0031"
        />
        <ellipse
          cx="104.2"
          cy="251.681"
          rx="0.488394"
          ry="0.495473"
          fill="#DD0031"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M113.761 247.202C114.344 246.276 114.657 245.203 114.667 244.105C114.667 240.365 111.048 237.333 106.601 237.333C102.155 237.333 98.5395 240.365 98.5395 244.088C98.5398 244.581 98.6037 245.073 98.7295 245.55C95.5922 246.472 93.3334 248.98 93.3334 251.922C93.3396 253.026 93.6535 254.106 94.2389 255.036L93.3707 257.978C93.3096 258.178 93.3709 258.395 93.5267 258.532C93.621 258.615 93.7411 258.661 93.8659 258.663C93.9405 258.664 94.0145 258.648 94.0829 258.618L96.725 257.428C98.1451 258.255 99.7575 258.683 101.395 258.666C105.842 258.666 109.461 255.638 109.461 251.912C109.461 251.421 109.399 250.931 109.274 250.456C109.975 250.253 110.648 249.963 111.278 249.593L113.917 250.797C114.106 250.879 114.324 250.846 114.48 250.711C114.636 250.574 114.697 250.357 114.636 250.157L113.761 247.202ZM101.395 257.61C99.865 257.622 98.3628 257.193 97.0642 256.371C96.9801 256.317 96.8824 256.288 96.7827 256.289C96.7079 256.29 96.6341 256.306 96.5656 256.337L94.707 257.176L95.3209 255.112C95.3646 254.957 95.3385 254.791 95.2497 254.658C94.6951 253.856 94.3946 252.902 94.3882 251.922C94.3882 249.328 96.5419 247.14 99.4757 246.458C99.4926 246.46 99.5096 246.46 99.5265 246.458C99.9728 246.355 100.426 246.289 100.883 246.259C101.015 246.259 101.148 246.259 101.28 246.242H101.426C105.282 246.242 108.413 248.798 108.413 251.926C108.413 255.053 105.262 257.61 101.395 257.61ZM112.898 245.93C113.002 245.862 113.133 245.855 113.242 245.911V245.904C113.48 245.33 113.604 244.714 113.605 244.091C113.601 243.501 113.486 242.917 113.266 242.371C113.208 242.413 113.14 242.437 113.069 242.439C112.882 242.439 112.73 242.285 112.73 242.095C112.724 241.937 112.825 241.795 112.974 241.751C112.792 241.426 112.577 241.121 112.333 240.84C112.435 240.978 112.428 241.169 112.318 241.299C112.207 241.43 112.022 241.465 111.872 241.385C111.722 241.304 111.647 241.128 111.692 240.962C111.737 240.796 111.889 240.684 112.059 240.692C112.137 240.693 112.213 240.722 112.272 240.774C111.996 240.466 111.69 240.186 111.36 239.938C111.362 239.957 111.362 239.977 111.36 239.997C111.36 240.187 111.208 240.341 111.021 240.341C110.833 240.341 110.682 240.187 110.682 239.997C110.68 239.825 110.803 239.678 110.97 239.652C110.729 239.497 110.48 239.356 110.224 239.229C110.164 239.28 110.088 239.308 110.01 239.308C109.83 239.309 109.682 239.167 109.671 238.985C108.697 238.604 107.662 238.411 106.618 238.417C105.796 238.413 104.977 238.529 104.187 238.761C104.283 238.872 104.298 239.033 104.225 239.161C104.152 239.289 104.007 239.355 103.864 239.326C103.677 239.326 103.525 239.172 103.525 238.981C101.687 239.714 100.29 241.087 99.7945 242.749C99.9818 242.749 100.134 242.903 100.134 243.093C100.134 243.283 99.9818 243.437 99.7945 243.437C99.7399 243.436 99.6864 243.422 99.6385 243.396C99.6045 243.624 99.5863 243.854 99.5842 244.084C99.5846 244.34 99.6073 244.596 99.652 244.848C99.6972 244.829 99.7455 244.818 99.7945 244.817C99.9818 244.817 100.134 244.971 100.134 245.161C100.132 245.19 100.126 245.219 100.117 245.247C100.544 245.191 100.975 245.163 101.405 245.165H101.507C101.507 244.975 101.659 244.82 101.846 244.82C102.034 244.82 102.186 244.975 102.186 245.165V245.192C102.674 245.228 103.16 245.302 103.637 245.412C103.542 245.299 103.53 245.136 103.607 245.009C103.685 244.882 103.834 244.82 103.977 244.856C104.119 244.891 104.223 245.016 104.234 245.165C104.238 245.328 104.129 245.471 103.973 245.509C106.222 246.125 108.063 247.539 108.942 249.417C109.192 249.344 109.439 249.258 109.681 249.159C109.734 249.028 109.86 248.944 110 248.946C110.041 248.947 110.081 248.955 110.119 248.97C110.371 248.85 110.617 248.715 110.855 248.568C110.716 248.482 110.657 248.309 110.713 248.155C110.769 248.001 110.925 247.908 111.085 247.934C111.245 247.96 111.364 248.097 111.37 248.261C111.368 248.326 111.35 248.389 111.316 248.444C111.357 248.451 111.397 248.464 111.435 248.481L113.276 249.321L113.069 248.633C112.979 248.633 112.893 248.597 112.829 248.532C112.766 248.468 112.73 248.38 112.73 248.289C112.732 248.17 112.793 248.061 112.893 248L112.666 247.267C112.627 247.112 112.658 246.948 112.75 246.82C112.815 246.727 112.873 246.63 112.93 246.534C112.821 246.477 112.749 246.366 112.742 246.241C112.736 246.117 112.795 245.998 112.898 245.93Z"
          fill="#DD0031"
        />
        <path
          d="M113.079 243.785C112.892 243.785 112.74 243.939 112.74 244.129C112.74 244.319 112.892 244.473 113.079 244.473C113.267 244.473 113.419 244.319 113.419 244.129C113.419 243.939 113.267 243.785 113.079 243.785Z"
          fill="#DD0031"
        />
        <path
          d="M112.059 242.749C111.871 242.749 111.719 242.903 111.719 243.093C111.719 243.283 111.871 243.437 112.059 243.437C112.246 243.437 112.398 243.283 112.398 243.093C112.398 242.903 112.246 242.749 112.059 242.749V242.749Z"
          fill="#DD0031"
        />
        <path
          d="M112.059 244.82C111.871 244.82 111.719 244.975 111.719 245.165C111.719 245.355 111.871 245.509 112.059 245.509C112.246 245.509 112.398 245.355 112.398 245.165C112.398 244.975 112.246 244.82 112.059 244.82Z"
          fill="#DD0031"
        />
        <path
          d="M112.059 246.895C111.871 246.895 111.719 247.049 111.719 247.239C111.719 247.429 111.871 247.583 112.059 247.583C112.246 247.583 112.398 247.429 112.398 247.239C112.398 247.049 112.246 246.895 112.059 246.895Z"
          fill="#DD0031"
        />
        <path
          d="M108.992 239.639C108.805 239.639 108.653 239.793 108.653 239.983C108.653 240.173 108.805 240.327 108.992 240.327C109.18 240.327 109.332 240.173 109.332 239.983C109.332 239.793 109.18 239.639 108.992 239.639Z"
          fill="#DD0031"
        />
        <path
          d="M107.971 238.603C107.784 238.603 107.632 238.757 107.632 238.947C107.632 239.137 107.784 239.291 107.971 239.291C108.159 239.291 108.311 239.137 108.311 238.947C108.311 238.757 108.159 238.603 107.971 238.603V238.603Z"
          fill="#DD0031"
        />
        <path
          d="M110.013 240.674C109.826 240.674 109.674 240.828 109.674 241.018C109.674 241.208 109.826 241.363 110.013 241.363C110.201 241.363 110.353 241.208 110.353 241.018C110.353 240.828 110.201 240.674 110.013 240.674Z"
          fill="#DD0031"
        />
        <path
          d="M107.971 240.674C107.784 240.674 107.632 240.828 107.632 241.018C107.632 241.208 107.784 241.363 107.971 241.363C108.159 241.363 108.311 241.208 108.311 241.018C108.311 240.828 108.159 240.674 107.971 240.674Z"
          fill="#DD0031"
        />
        <path
          d="M108.992 243.785C108.805 243.785 108.653 243.939 108.653 244.129C108.653 244.319 108.805 244.473 108.992 244.473C109.18 244.473 109.332 244.319 109.332 244.129C109.332 243.939 109.18 243.785 108.992 243.785Z"
          fill="#DD0031"
        />
        <path
          d="M111.038 243.785C110.85 243.785 110.698 243.939 110.698 244.129C110.698 244.319 110.85 244.473 111.038 244.473C111.225 244.473 111.377 244.319 111.377 244.129C111.377 243.939 111.225 243.785 111.038 243.785Z"
          fill="#DD0031"
        />
        <path
          d="M110.013 242.749C109.826 242.749 109.674 242.903 109.674 243.093C109.674 243.283 109.826 243.437 110.013 243.437C110.201 243.437 110.353 243.283 110.353 243.093C110.353 242.903 110.201 242.749 110.013 242.749V242.749Z"
          fill="#DD0031"
        />
        <path
          d="M107.971 242.749C107.784 242.749 107.632 242.903 107.632 243.093C107.632 243.283 107.784 243.437 107.971 243.437C108.159 243.437 108.311 243.283 108.311 243.093C108.311 242.903 108.159 242.749 107.971 242.749V242.749Z"
          fill="#DD0031"
        />
        <path
          d="M110.013 244.82C109.826 244.82 109.674 244.975 109.674 245.165C109.674 245.355 109.826 245.509 110.013 245.509C110.201 245.509 110.353 245.355 110.353 245.165C110.353 244.975 110.201 244.82 110.013 244.82Z"
          fill="#DD0031"
        />
        <path
          d="M107.971 244.82C107.784 244.82 107.632 244.975 107.632 245.165C107.632 245.355 107.784 245.509 107.971 245.509C108.159 245.509 108.311 245.355 108.311 245.165C108.311 244.975 108.159 244.82 107.971 244.82Z"
          fill="#DD0031"
        />
        <path
          d="M108.992 241.713C108.805 241.713 108.653 241.867 108.653 242.058C108.653 242.248 108.805 242.402 108.992 242.402C109.18 242.402 109.332 242.248 109.332 242.058C109.332 241.867 109.18 241.713 108.992 241.713Z"
          fill="#DD0031"
        />
        <path
          d="M111.038 241.713C110.85 241.713 110.698 241.867 110.698 242.058C110.698 242.248 110.85 242.402 111.038 242.402C111.225 242.402 111.377 242.248 111.377 242.058C111.377 241.867 111.225 241.713 111.038 241.713Z"
          fill="#DD0031"
        />
        <path
          d="M108.992 247.931C108.805 247.931 108.653 248.085 108.653 248.275C108.653 248.465 108.805 248.619 108.992 248.619C109.18 248.619 109.332 248.465 109.332 248.275C109.332 248.085 109.18 247.931 108.992 247.931Z"
          fill="#DD0031"
        />
        <path
          d="M110.013 246.895C109.826 246.895 109.674 247.049 109.674 247.239C109.674 247.429 109.826 247.583 110.013 247.583C110.201 247.583 110.353 247.429 110.353 247.239C110.353 247.049 110.201 246.895 110.013 246.895Z"
          fill="#DD0031"
        />
        <path
          d="M107.971 246.895C107.784 246.895 107.632 247.049 107.632 247.239C107.632 247.429 107.784 247.583 107.971 247.583C108.159 247.583 108.311 247.429 108.311 247.239C108.311 247.049 108.159 246.895 107.971 246.895Z"
          fill="#DD0031"
        />
        <path
          d="M108.992 245.856C108.805 245.856 108.653 246.01 108.653 246.2C108.653 246.39 108.805 246.544 108.992 246.544C109.18 246.544 109.332 246.39 109.332 246.2C109.332 246.01 109.18 245.856 108.992 245.856Z"
          fill="#DD0031"
        />
        <path
          d="M111.038 245.856C110.85 245.856 110.698 246.01 110.698 246.2C110.698 246.39 110.85 246.544 111.038 246.544C111.225 246.544 111.377 246.39 111.377 246.2C111.377 246.01 111.225 245.856 111.038 245.856Z"
          fill="#DD0031"
        />
        <path
          d="M104.906 239.639C104.718 239.639 104.566 239.793 104.566 239.983C104.566 240.173 104.718 240.327 104.906 240.327C105.093 240.327 105.245 240.173 105.245 239.983C105.245 239.793 105.093 239.639 104.906 239.639Z"
          fill="#DD0031"
        />
        <path
          d="M106.951 239.639C106.763 239.639 106.611 239.793 106.611 239.983C106.611 240.173 106.763 240.327 106.951 240.327C107.138 240.327 107.29 240.173 107.29 239.983C107.29 239.793 107.138 239.639 106.951 239.639Z"
          fill="#DD0031"
        />
        <path
          d="M105.93 238.603C105.743 238.603 105.591 238.757 105.591 238.947C105.591 239.137 105.743 239.291 105.93 239.291C106.117 239.291 106.269 239.137 106.269 238.947C106.269 238.757 106.117 238.603 105.93 238.603V238.603Z"
          fill="#DD0031"
        />
        <path
          d="M105.93 240.674C105.743 240.674 105.591 240.828 105.591 241.018C105.591 241.208 105.743 241.363 105.93 241.363C106.117 241.363 106.269 241.208 106.269 241.018C106.269 240.828 106.117 240.674 105.93 240.674Z"
          fill="#DD0031"
        />
        <path
          d="M103.885 240.674C103.697 240.674 103.546 240.828 103.546 241.018C103.546 241.208 103.697 241.363 103.885 241.363C104.072 241.363 104.224 241.208 104.224 241.018C104.224 240.828 104.072 240.674 103.885 240.674Z"
          fill="#DD0031"
        />
        <path
          d="M104.906 243.785C104.718 243.785 104.566 243.939 104.566 244.129C104.566 244.319 104.718 244.473 104.906 244.473C105.093 244.473 105.245 244.319 105.245 244.129C105.245 243.939 105.093 243.785 104.906 243.785Z"
          fill="#DD0031"
        />
        <path
          d="M106.951 243.785C106.763 243.785 106.611 243.939 106.611 244.129C106.611 244.319 106.763 244.473 106.951 244.473C107.138 244.473 107.29 244.319 107.29 244.129C107.29 243.939 107.138 243.785 106.951 243.785Z"
          fill="#DD0031"
        />
        <path
          d="M105.93 242.749C105.743 242.749 105.591 242.903 105.591 243.093C105.591 243.283 105.743 243.437 105.93 243.437C106.117 243.437 106.269 243.283 106.269 243.093C106.269 242.903 106.117 242.749 105.93 242.749V242.749Z"
          fill="#DD0031"
        />
        <path
          d="M103.885 242.749C103.697 242.749 103.546 242.903 103.546 243.093C103.546 243.283 103.697 243.437 103.885 243.437C104.072 243.437 104.224 243.283 104.224 243.093C104.224 242.903 104.072 242.749 103.885 242.749V242.749Z"
          fill="#DD0031"
        />
        <path
          d="M105.93 244.82C105.743 244.82 105.591 244.975 105.591 245.165C105.591 245.355 105.743 245.509 105.93 245.509C106.117 245.509 106.269 245.355 106.269 245.165C106.269 244.975 106.117 244.82 105.93 244.82Z"
          fill="#DD0031"
        />
        <path
          d="M104.906 241.713C104.718 241.713 104.566 241.867 104.566 242.058C104.566 242.248 104.718 242.402 104.906 242.402C105.093 242.402 105.245 242.248 105.245 242.058C105.245 241.867 105.093 241.713 104.906 241.713Z"
          fill="#DD0031"
        />
        <path
          d="M106.951 241.713C106.763 241.713 106.611 241.867 106.611 242.058C106.611 242.248 106.763 242.402 106.951 242.402C107.138 242.402 107.29 242.248 107.29 242.058C107.29 241.867 107.138 241.713 106.951 241.713Z"
          fill="#DD0031"
        />
        <path
          d="M106.951 245.856C106.763 245.856 106.611 246.01 106.611 246.2C106.611 246.39 106.763 246.544 106.951 246.544C107.138 246.544 107.29 246.39 107.29 246.2C107.29 246.01 107.138 245.856 106.951 245.856Z"
          fill="#DD0031"
        />
        <path
          d="M102.864 239.639C102.677 239.639 102.525 239.793 102.525 239.983C102.525 240.173 102.677 240.327 102.864 240.327C103.051 240.327 103.203 240.173 103.203 239.983C103.203 239.793 103.051 239.639 102.864 239.639Z"
          fill="#DD0031"
        />
        <path
          d="M101.843 240.674C101.656 240.674 101.504 240.828 101.504 241.018C101.504 241.208 101.656 241.363 101.843 241.363C102.03 241.363 102.182 241.208 102.182 241.018C102.182 240.828 102.03 240.674 101.843 240.674Z"
          fill="#DD0031"
        />
        <path
          d="M100.822 243.785C100.635 243.785 100.483 243.939 100.483 244.129C100.483 244.319 100.635 244.473 100.822 244.473C101.009 244.473 101.161 244.319 101.161 244.129C101.161 243.939 101.009 243.785 100.822 243.785Z"
          fill="#DD0031"
        />
        <path
          d="M102.864 243.785C102.677 243.785 102.525 243.939 102.525 244.129C102.525 244.319 102.677 244.473 102.864 244.473C103.051 244.473 103.203 244.319 103.203 244.129C103.203 243.939 103.051 243.785 102.864 243.785Z"
          fill="#DD0031"
        />
        <path
          d="M101.843 242.749C101.656 242.749 101.504 242.903 101.504 243.093C101.504 243.283 101.656 243.437 101.843 243.437C102.03 243.437 102.182 243.283 102.182 243.093C102.182 242.903 102.03 242.749 101.843 242.749V242.749Z"
          fill="#DD0031"
        />
        <path
          d="M100.822 241.713C100.635 241.713 100.483 241.867 100.483 242.058C100.483 242.248 100.635 242.402 100.822 242.402C101.009 242.402 101.161 242.248 101.161 242.058C101.161 241.867 101.009 241.713 100.822 241.713Z"
          fill="#DD0031"
        />
        <path
          d="M102.864 241.713C102.677 241.713 102.525 241.867 102.525 242.058C102.525 242.248 102.677 242.402 102.864 242.402C103.051 242.402 103.203 242.248 103.203 242.058C103.203 241.867 103.051 241.713 102.864 241.713Z"
          fill="#DD0031"
        />
        <rect
          x="82"
          y="226"
          width="44"
          height="44"
          rx="22"
          stroke="#DD0031"
          strokeWidth="4"
        />
        <text
          fill="#DD0031"
          xmlSpace="preserve"
          style={{ whiteSpace: "pre" }}
          fontFamily="Apercu"
          fontSize="20"
          fontWeight="bold"
          letterSpacing="0em"
        >
          <tspan x="136" y="255.76">
            Apply
          </tspan>
        </text>
        <text
          fill="#5B6770"
          xmlSpace="preserve"
          style={{ whiteSpace: "pre" }}
          fontFamily="Apercu"
          fontSize="14"
          fontWeight="bold"
          letterSpacing="0em"
        >
          <tspan x="136" y="188.032">
            ~13 MONTHS PRE-GRAND OPENING
          </tspan>
        </text>
        <rect x="82" y="134" width="44" height="44" rx="22" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M112.59 146.929L114.606 150.43C114.693 150.593 114.686 150.789 114.588 150.947C114.494 151.105 114.321 151.202 114.135 151.202H113.35V164.847C113.35 165.114 113.132 165.331 112.862 165.333H95.1336C94.862 165.333 94.6419 165.116 94.6419 164.847V151.202H93.8573C93.6712 151.202 93.4989 151.105 93.404 150.947C93.3098 150.787 93.3098 150.589 93.404 150.43L95.4265 146.929C95.5172 146.77 95.6854 146.671 95.8694 146.667H112.137C112.325 146.666 112.498 146.766 112.59 146.929ZM111.833 147.7H96.1762L94.7709 150.157H113.252L113.075 149.851C113.041 149.862 113.006 149.869 112.97 149.871C112.735 149.871 112.543 149.684 112.541 149.451C112.54 149.337 112.587 149.227 112.67 149.148L112.116 148.186C112.132 148.229 112.142 148.275 112.144 148.321C112.144 148.555 111.952 148.745 111.715 148.745C111.478 148.745 111.286 148.555 111.286 148.321C111.286 148.087 111.478 147.897 111.715 147.897C111.838 147.897 111.956 147.952 112.035 148.045L111.833 147.7ZM104.493 164.32V156.687H110.421V164.32H104.493ZM98.122 154.482L97.2154 155.778H110.853L109.95 154.482H98.122ZM97.6408 156.687H103.593V164.32H97.6408V156.687ZM111.31 164.365H112.384V151.202H111.816V151.777C111.816 152.045 111.596 152.263 111.324 152.263C111.053 152.263 110.833 152.045 110.833 151.777V151.202H109.713V151.777C109.713 152.045 109.493 152.263 109.222 152.263C108.95 152.263 108.73 152.045 108.73 151.777V151.202H107.611V151.777C107.626 151.96 107.536 152.136 107.378 152.232C107.22 152.328 107.021 152.328 106.863 152.232C106.705 152.136 106.615 151.96 106.631 151.777V151.202H105.511V151.777C105.511 152.045 105.291 152.263 105.02 152.263C104.748 152.263 104.528 152.045 104.528 151.777V151.202H103.402V151.777C103.417 151.96 103.327 152.136 103.169 152.232C103.011 152.328 102.812 152.328 102.654 152.232C102.496 152.136 102.406 151.96 102.422 151.777V151.202H101.302V151.777C101.302 152.045 101.082 152.263 100.811 152.263C100.539 152.263 100.319 152.045 100.319 151.777V151.202H99.1996V151.777C99.1996 152.045 98.9795 152.263 98.708 152.263C98.4364 152.263 98.2163 152.045 98.2163 151.777V151.202H97.1039V151.777C97.1195 151.96 97.0297 152.136 96.8717 152.232C96.7136 152.328 96.5143 152.328 96.3563 152.232C96.1982 152.136 96.1084 151.96 96.124 151.777V151.202H95.6254V164.365H96.7587V156.66H96.3646C96.1992 156.66 96.0471 156.57 95.9697 156.425C95.8922 156.281 95.9019 156.106 95.995 155.971L97.5189 153.789C97.601 153.669 97.7381 153.597 97.885 153.596H110.184C110.332 153.597 110.47 153.669 110.554 153.789L112.074 155.971C112.167 156.105 112.177 156.28 112.1 156.424C112.024 156.568 111.873 156.659 111.708 156.66H111.289L111.31 164.365Z"
          fill="#DD0031"
        />
        <ellipse
          cx="98.2651"
          cy="149.461"
          rx="0.428913"
          ry="0.423851"
          fill="#DD0031"
        />
        <ellipse
          cx="99.109"
          cy="155.202"
          rx="0.428913"
          ry="0.423851"
          fill="#DD0031"
        />
        <ellipse
          cx="101.578"
          cy="155.202"
          rx="0.428913"
          ry="0.423851"
          fill="#DD0031"
        />
        <ellipse
          cx="104.047"
          cy="155.202"
          rx="0.428913"
          ry="0.423851"
          fill="#DD0031"
        />
        <ellipse
          cx="106.519"
          cy="155.202"
          rx="0.428913"
          ry="0.423851"
          fill="#DD0031"
        />
        <ellipse
          cx="108.988"
          cy="155.202"
          rx="0.428912"
          ry="0.423851"
          fill="#DD0031"
        />
        <ellipse
          cx="95.7963"
          cy="149.461"
          rx="0.428913"
          ry="0.423851"
          fill="#DD0031"
        />
        <ellipse
          cx="103.206"
          cy="149.461"
          rx="0.428913"
          ry="0.423851"
          fill="#DD0031"
        />
        <ellipse
          cx="100.734"
          cy="149.461"
          rx="0.428913"
          ry="0.423851"
          fill="#DD0031"
        />
        <ellipse
          cx="97.0131"
          cy="148.331"
          rx="0.428913"
          ry="0.423851"
          fill="#DD0031"
        />
        <ellipse
          cx="101.951"
          cy="148.331"
          rx="0.428913"
          ry="0.423851"
          fill="#DD0031"
        />
        <ellipse
          cx="99.482"
          cy="148.331"
          rx="0.428913"
          ry="0.423851"
          fill="#DD0031"
        />
        <ellipse
          cx="105.647"
          cy="149.461"
          rx="0.428913"
          ry="0.423851"
          fill="#DD0031"
        />
        <ellipse
          cx="110.585"
          cy="149.461"
          rx="0.428913"
          ry="0.423851"
          fill="#DD0031"
        />
        <ellipse
          cx="108.116"
          cy="149.461"
          rx="0.428913"
          ry="0.423851"
          fill="#DD0031"
        />
        <ellipse
          cx="104.392"
          cy="148.331"
          rx="0.428913"
          ry="0.423851"
          fill="#DD0031"
        />
        <ellipse
          cx="109.333"
          cy="148.331"
          rx="0.428912"
          ry="0.423851"
          fill="#DD0031"
        />
        <ellipse
          cx="106.864"
          cy="148.331"
          rx="0.428913"
          ry="0.423851"
          fill="#DD0031"
        />
        <rect
          x="82"
          y="134"
          width="44"
          height="44"
          rx="22"
          stroke="#DD0031"
          strokeWidth="4"
        />
        <text
          fill="#DD0031"
          xmlSpace="preserve"
          style={{ whiteSpace: "pre" }}
          fontFamily="Apercu"
          fontSize="20"
          fontWeight="bold"
          letterSpacing="0em"
        >
          <tspan x="136.498" y="161.76">
            Activate
          </tspan>
        </text>
        <text
          fill="#5B6770"
          xmlSpace="preserve"
          style={{ whiteSpace: "pre" }}
          fontFamily="Apercu"
          fontSize="16"
          fontWeight="bold"
          letterSpacing="0em"
        >
          <tspan x="5.5" y="196.608">
            {dayjs(recruitPhase1Date).format("MMM DD")}
          </tspan>
        </text>
        <g
          fill={
            dayjs().isSameOrAfter(recruitPhase1Date)
              ? dayjs().isBefore(recruitPhase2Date)
                ? "#DD0031"
                : "#004F71"
              : "#3EB1C8"
          }
        >
          <path
            d="M18 218V208L28 218L38 208V218H28H18Z"
            className="phase-1"
            // fill="#004F71"
          />
          <rect
            width="60"
            height="20"
            transform="translate(38 218) rotate(90)"
            className="phase-1"
            // fill="#004F71"
          />
          <path
            d="M18 278H38L28 288L18 278Z"
            className="phase-1"
            // fill="#004F71"
          />
        </g>
        <text
          fill="#5B6770"
          xmlSpace="preserve"
          style={{ whiteSpace: "pre" }}
          fontFamily="Apercu"
          fontSize="16"
          fontWeight="bold"
          letterSpacing="0em"
        >
          <tspan x="4.5" y="308.608">
            {dayjs(recruitPhase2Date).format("MMM DD")}
          </tspan>
        </text>
        <g
          fill={
            dayjs().isSameOrAfter(recruitPhase2Date)
              ? dayjs().isBefore(recruitPhase5Date)
                ? "#DD0031"
                : "#004F71"
              : "#3EB1C8"
          }
        >
          <path
            d="M18 330V320L28 330L38 320V330H28H18Z"
            className="phase-2"
            // fill="#DD0031"
          />
          <rect
            width="20"
            height="20"
            transform="translate(38 330) rotate(90)"
            className="phase-2"
            // fill="#DD0031"
          />
          <path
            d="M18 350H38L28 360L18 350Z"
            className="phase-2"
            // fill="#DD0031"
          />
        </g>
        <text
          fill="#5B6770"
          xmlSpace="preserve"
          style={{ whiteSpace: "pre" }}
          fontFamily="Apercu"
          fontSize="16"
          fontWeight="bold"
          letterSpacing="0em"
        />
        <text
          fill="#5B6770"
          xmlSpace="preserve"
          style={{ whiteSpace: "pre" }}
          fontFamily="Apercu"
          fontSize="16"
          fontWeight="bold"
          letterSpacing="0em"
        >
          <tspan x="3.5" y="382.608">
            {dayjs(recruitPhase5Date).format("MMM DD")}
          </tspan>
        </text>
        <path d="M18 404V394L28 404L38 394V404H28H18Z" fill="#A7ACAF" />
        <rect
          width="100"
          height="20"
          transform="translate(38 404) rotate(90)"
          fill="#A7ACAF"
        />
        <path d="M18 504H38L28 514L18 504Z" fill="#A7ACAF" />
        <defs>
          <clipPath id="clip0_2_397">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(92 480)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  }
  return (
    <svg
      width="363"
      height="744"
      viewBox="0 0 363 744"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "block", margin: "auto" }}
    >
      <text
        fill="#004F71"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="20"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="104.925" y="21.76">
          Multi-Restaurant&#10;
        </tspan>
        <tspan x="74.675" y="53.76">
          Activation and Timeline
        </tspan>
      </text>
      <text
        fill="#5B6770"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="14"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="45.5195" y="84.032">
          FOR GRAND OPENING RESTAURANTS ONLY&#10;
        </tspan>
        <tspan x="146.801" y="108.032">
          ~13 WEEKS
        </tspan>
      </text>
      <line
        x1="104.5"
        y1="182"
        x2="104.5"
        y2="620"
        stroke="#DD0031"
        strokeWidth="4"
        strokeLinecap="round"
        strokeDasharray="0.25 10"
      />
      <text
        fill="#5B6770"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="14"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="135.5" y="676.032">
          IF NOT MULTI-RESTAURANT FIRST,{" "}
        </tspan>
        <tspan x="135.5" y="700.032">
          THEN ACTIVATE FOR STANDARD{" "}
        </tspan>
        <tspan x="135.5" y="724.032">
          SELECTION
        </tspan>
      </text>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.1266 644C94.1266 638.547 98.5471 634.127 104 634.127C109.453 634.127 113.873 638.547 113.873 644C113.873 649.453 109.453 653.873 104 653.873C98.5471 653.873 94.1266 649.453 94.1266 644ZM104 632C97.3726 632 92 637.373 92 644C92 650.627 97.3726 656 104 656C110.627 656 116 650.627 116 644C116 637.373 110.627 632 104 632ZM108.397 642.321C108.813 641.906 108.813 641.233 108.397 640.818C107.982 640.403 107.309 640.403 106.894 640.818L102.785 644.927L101.106 643.248C100.691 642.833 100.018 642.833 99.6026 643.248C99.1873 643.663 99.1873 644.337 99.6026 644.752L102.033 647.182C102.448 647.597 103.121 647.597 103.537 647.182L108.397 642.321Z"
        fill="#DD0031"
      />
      <rect
        x="82"
        y="622"
        width="44"
        height="44"
        rx="22"
        stroke="#DD0031"
        strokeWidth="4"
      />
      <text
        fill="#DD0031"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="20"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="136.111" y="649.76">
          Select
        </tspan>
      </text>
      <rect x="82" y="470" width="44" height="44" rx="22" fill="white" />
      <g clip-path="url(#clip0_2_397)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M94.4 489.6C94.4 485.624 97.6235 482.4 101.6 482.4C105.576 482.4 108.8 485.624 108.8 489.6C108.8 493.576 105.576 496.8 101.6 496.8C97.6235 496.8 94.4 493.576 94.4 489.6ZM101.6 480C96.2981 480 92 484.298 92 489.6C92 494.902 96.2981 499.2 101.6 499.2C103.818 499.2 105.861 498.447 107.487 497.184L113.951 503.649C114.42 504.117 115.18 504.117 115.649 503.649C116.117 503.18 116.117 502.42 115.649 501.951L109.184 495.487C110.447 493.861 111.2 491.818 111.2 489.6C111.2 484.298 106.902 480 101.6 480Z"
          fill="#DD0031"
        />
      </g>
      <rect
        x="82"
        y="470"
        width="44"
        height="44"
        rx="22"
        stroke="#DD0031"
        strokeWidth="4"
      />
      <text
        fill="#DD0031"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="20"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="136" y="465.76">
          Assess&#10;
        </tspan>
        <tspan x="136" y="497.76">
          Decide&#10;
        </tspan>
        <tspan x="136" y="529.76">
          Communicate
        </tspan>
      </text>
      <rect x="82" y="318" width="44" height="44" rx="22" fill="white" />
      <ellipse
        cx="99.7268"
        cy="331.79"
        rx="0.455704"
        ry="0.450937"
        fill="#DD0031"
      />
      <ellipse
        cx="102.217"
        cy="331.79"
        rx="0.455704"
        ry="0.450937"
        fill="#DD0031"
      />
      <path
        d="M105.043 332.241C105.228 332.242 105.395 332.133 105.467 331.965C105.539 331.796 105.501 331.602 105.371 331.472C105.241 331.342 105.044 331.303 104.873 331.373C104.703 331.442 104.591 331.607 104.591 331.79C104.591 332.037 104.793 332.239 105.043 332.241Z"
        fill="#DD0031"
      />
      <path
        d="M107.533 332.241C107.718 332.242 107.885 332.133 107.957 331.965C108.028 331.796 107.99 331.602 107.86 331.472C107.73 331.342 107.534 331.303 107.363 331.373C107.192 331.442 107.081 331.607 107.081 331.79C107.081 332.037 107.283 332.239 107.533 332.241Z"
        fill="#DD0031"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M114.347 334.137C114.841 334.193 115.293 334.443 115.599 334.833C116.238 335.635 116.099 336.799 115.287 337.432L113.991 338.455L114.732 339.379C114.917 339.617 114.874 339.958 114.635 340.145L110.931 343.052V350.117C110.931 350.42 110.682 350.667 110.375 350.667H97.2224C96.9154 350.667 96.6666 350.42 96.6666 350.117V329.883C96.6666 329.58 96.9154 329.333 97.2224 329.333H110.375C110.677 329.339 110.919 329.584 110.919 329.883V336.149L112.968 334.536C113.355 334.225 113.852 334.081 114.347 334.137ZM97.9856 330.433H97.7781V333.043H98.0041C98.0558 332.851 98.2322 332.716 98.4339 332.716C98.6356 332.716 98.812 332.851 98.8637 333.043H100.494C100.545 332.851 100.722 332.716 100.924 332.716C101.125 332.716 101.302 332.851 101.353 333.043H103.324C103.373 332.849 103.55 332.712 103.752 332.712C103.955 332.712 104.131 332.849 104.18 333.043H105.81C105.862 332.851 106.038 332.716 106.24 332.716C106.442 332.716 106.618 332.851 106.67 333.043H108.656C108.707 332.851 108.884 332.716 109.085 332.716C109.287 332.716 109.464 332.851 109.515 333.043H109.856V330.433H109.534C109.535 330.443 109.535 330.453 109.534 330.463C109.549 330.633 109.466 330.797 109.32 330.887C109.173 330.977 108.987 330.977 108.84 330.887C108.693 330.797 108.611 330.633 108.626 330.463V330.433H106.725C106.727 330.443 106.727 330.453 106.725 330.463C106.741 330.633 106.658 330.797 106.511 330.887C106.364 330.977 106.179 330.977 106.032 330.887C105.885 330.797 105.802 330.633 105.818 330.463V330.433H104.228V330.463C104.244 330.633 104.161 330.797 104.014 330.887C103.867 330.977 103.682 330.977 103.535 330.887C103.388 330.797 103.305 330.633 103.321 330.463V330.433H101.39V330.463C101.406 330.633 101.323 330.797 101.176 330.887C101.029 330.977 100.844 330.977 100.697 330.887C100.55 330.797 100.467 330.633 100.483 330.463C100.481 330.453 100.481 330.443 100.483 330.433H98.8896V330.463C98.8604 330.688 98.6668 330.856 98.4376 330.856C98.2083 330.856 98.0148 330.688 97.9856 330.463V330.433ZM109.808 349.567H97.7781V334.169H109.808V337.032L102.643 342.667C102.572 342.723 102.517 342.795 102.48 342.876L101.583 344.889C101.53 345.018 101.53 345.163 101.583 345.292L101.001 345.75C100.761 345.94 100.721 346.286 100.912 346.524C101.104 346.762 101.454 346.801 101.694 346.612L102.268 346.157C102.36 346.22 102.468 346.255 102.58 346.256C102.631 346.256 102.682 346.249 102.732 346.234L104.788 345.666C104.859 345.646 104.926 345.612 104.984 345.567L109.801 341.758L109.808 349.567ZM104.51 344.526L109.808 340.354L110.919 339.478L112.45 338.271L111.52 337.084L110.919 337.553L109.808 338.429L103.536 343.371L104.51 344.526ZM110.919 341.648V340.882L113.142 339.14L113.513 339.621L110.919 341.648ZM114.606 336.574C114.766 336.451 114.867 336.268 114.887 336.068H114.906C114.961 335.76 114.811 335.451 114.535 335.3C114.258 335.148 113.914 335.187 113.68 335.397L112.409 336.398L113.339 337.586L114.606 336.574Z"
        fill="#DD0031"
      />
      <rect
        x="82"
        y="318"
        width="44"
        height="44"
        rx="22"
        stroke="#DD0031"
        strokeWidth="4"
      />
      <text
        fill="#DD0031"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="20"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="136.404" y="335.76">
          Application&#10;
        </tspan>
        <tspan x="136.404" y="367.76">
          Review
        </tspan>
      </text>
      <rect x="82" y="226" width="44" height="44" rx="22" fill="white" />
      <ellipse
        cx="98.5937"
        cy="251.681"
        rx="0.488394"
        ry="0.495473"
        fill="#DD0031"
      />
      <ellipse
        cx="101.399"
        cy="251.681"
        rx="0.488394"
        ry="0.495473"
        fill="#DD0031"
      />
      <ellipse
        cx="104.2"
        cy="251.681"
        rx="0.488394"
        ry="0.495473"
        fill="#DD0031"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.761 247.202C114.344 246.276 114.657 245.203 114.667 244.105C114.667 240.365 111.048 237.333 106.601 237.333C102.155 237.333 98.5395 240.365 98.5395 244.088C98.5398 244.581 98.6037 245.073 98.7295 245.55C95.5922 246.472 93.3334 248.98 93.3334 251.922C93.3396 253.026 93.6535 254.106 94.2389 255.036L93.3707 257.978C93.3096 258.178 93.3709 258.395 93.5267 258.532C93.621 258.615 93.7411 258.661 93.8659 258.663C93.9405 258.664 94.0145 258.648 94.0829 258.618L96.725 257.428C98.1451 258.255 99.7575 258.683 101.395 258.666C105.842 258.666 109.461 255.638 109.461 251.912C109.461 251.421 109.399 250.931 109.274 250.456C109.975 250.253 110.648 249.963 111.278 249.593L113.917 250.797C114.106 250.879 114.324 250.846 114.48 250.711C114.636 250.574 114.697 250.357 114.636 250.157L113.761 247.202ZM101.395 257.61C99.865 257.622 98.3628 257.193 97.0642 256.371C96.9801 256.317 96.8824 256.288 96.7827 256.289C96.7079 256.29 96.6341 256.306 96.5656 256.337L94.707 257.176L95.3209 255.112C95.3646 254.957 95.3385 254.791 95.2497 254.658C94.6951 253.856 94.3946 252.902 94.3882 251.922C94.3882 249.328 96.5419 247.14 99.4757 246.458C99.4926 246.46 99.5096 246.46 99.5265 246.458C99.9728 246.355 100.426 246.289 100.883 246.259C101.015 246.259 101.148 246.259 101.28 246.242H101.426C105.282 246.242 108.413 248.798 108.413 251.926C108.413 255.053 105.262 257.61 101.395 257.61ZM112.898 245.93C113.002 245.862 113.133 245.855 113.242 245.911V245.904C113.48 245.33 113.604 244.714 113.605 244.091C113.601 243.501 113.486 242.917 113.266 242.371C113.208 242.413 113.14 242.437 113.069 242.439C112.882 242.439 112.73 242.285 112.73 242.095C112.724 241.937 112.825 241.795 112.974 241.751C112.792 241.426 112.577 241.121 112.333 240.84C112.435 240.978 112.428 241.169 112.318 241.299C112.207 241.43 112.022 241.465 111.872 241.385C111.722 241.304 111.647 241.128 111.692 240.962C111.737 240.796 111.889 240.684 112.059 240.692C112.137 240.693 112.213 240.722 112.272 240.774C111.996 240.466 111.69 240.186 111.36 239.938C111.362 239.957 111.362 239.977 111.36 239.997C111.36 240.187 111.208 240.341 111.021 240.341C110.833 240.341 110.682 240.187 110.682 239.997C110.68 239.825 110.803 239.678 110.97 239.652C110.729 239.497 110.48 239.356 110.224 239.229C110.164 239.28 110.088 239.308 110.01 239.308C109.83 239.309 109.682 239.167 109.671 238.985C108.697 238.604 107.662 238.411 106.618 238.417C105.796 238.413 104.977 238.529 104.187 238.761C104.283 238.872 104.298 239.033 104.225 239.161C104.152 239.289 104.007 239.355 103.864 239.326C103.677 239.326 103.525 239.172 103.525 238.981C101.687 239.714 100.29 241.087 99.7945 242.749C99.9818 242.749 100.134 242.903 100.134 243.093C100.134 243.283 99.9818 243.437 99.7945 243.437C99.7399 243.436 99.6864 243.422 99.6385 243.396C99.6045 243.624 99.5863 243.854 99.5842 244.084C99.5846 244.34 99.6073 244.596 99.652 244.848C99.6972 244.829 99.7455 244.818 99.7945 244.817C99.9818 244.817 100.134 244.971 100.134 245.161C100.132 245.19 100.126 245.219 100.117 245.247C100.544 245.191 100.975 245.163 101.405 245.165H101.507C101.507 244.975 101.659 244.82 101.846 244.82C102.034 244.82 102.186 244.975 102.186 245.165V245.192C102.674 245.228 103.16 245.302 103.637 245.412C103.542 245.299 103.53 245.136 103.607 245.009C103.685 244.882 103.834 244.82 103.977 244.856C104.119 244.891 104.223 245.016 104.234 245.165C104.238 245.328 104.129 245.471 103.973 245.509C106.222 246.125 108.063 247.539 108.942 249.417C109.192 249.344 109.439 249.258 109.681 249.159C109.734 249.028 109.86 248.944 110 248.946C110.041 248.947 110.081 248.955 110.119 248.97C110.371 248.85 110.617 248.715 110.855 248.568C110.716 248.482 110.657 248.309 110.713 248.155C110.769 248.001 110.925 247.908 111.085 247.934C111.245 247.96 111.364 248.097 111.37 248.261C111.368 248.326 111.35 248.389 111.316 248.444C111.357 248.451 111.397 248.464 111.435 248.481L113.276 249.321L113.069 248.633C112.979 248.633 112.893 248.597 112.829 248.532C112.766 248.468 112.73 248.38 112.73 248.289C112.732 248.17 112.793 248.061 112.893 248L112.666 247.267C112.627 247.112 112.658 246.948 112.75 246.82C112.815 246.727 112.873 246.63 112.93 246.534C112.821 246.477 112.749 246.366 112.742 246.241C112.736 246.117 112.795 245.998 112.898 245.93Z"
        fill="#DD0031"
      />
      <path
        d="M113.079 243.785C112.892 243.785 112.74 243.939 112.74 244.129C112.74 244.319 112.892 244.473 113.079 244.473C113.267 244.473 113.419 244.319 113.419 244.129C113.419 243.939 113.267 243.785 113.079 243.785Z"
        fill="#DD0031"
      />
      <path
        d="M112.059 242.749C111.871 242.749 111.719 242.903 111.719 243.093C111.719 243.283 111.871 243.437 112.059 243.437C112.246 243.437 112.398 243.283 112.398 243.093C112.398 242.903 112.246 242.749 112.059 242.749V242.749Z"
        fill="#DD0031"
      />
      <path
        d="M112.059 244.82C111.871 244.82 111.719 244.975 111.719 245.165C111.719 245.355 111.871 245.509 112.059 245.509C112.246 245.509 112.398 245.355 112.398 245.165C112.398 244.975 112.246 244.82 112.059 244.82Z"
        fill="#DD0031"
      />
      <path
        d="M112.059 246.895C111.871 246.895 111.719 247.049 111.719 247.239C111.719 247.429 111.871 247.583 112.059 247.583C112.246 247.583 112.398 247.429 112.398 247.239C112.398 247.049 112.246 246.895 112.059 246.895Z"
        fill="#DD0031"
      />
      <path
        d="M108.992 239.639C108.805 239.639 108.653 239.793 108.653 239.983C108.653 240.173 108.805 240.327 108.992 240.327C109.18 240.327 109.332 240.173 109.332 239.983C109.332 239.793 109.18 239.639 108.992 239.639Z"
        fill="#DD0031"
      />
      <path
        d="M107.971 238.603C107.784 238.603 107.632 238.757 107.632 238.947C107.632 239.137 107.784 239.291 107.971 239.291C108.159 239.291 108.311 239.137 108.311 238.947C108.311 238.757 108.159 238.603 107.971 238.603V238.603Z"
        fill="#DD0031"
      />
      <path
        d="M110.013 240.674C109.826 240.674 109.674 240.828 109.674 241.018C109.674 241.208 109.826 241.363 110.013 241.363C110.201 241.363 110.353 241.208 110.353 241.018C110.353 240.828 110.201 240.674 110.013 240.674Z"
        fill="#DD0031"
      />
      <path
        d="M107.971 240.674C107.784 240.674 107.632 240.828 107.632 241.018C107.632 241.208 107.784 241.363 107.971 241.363C108.159 241.363 108.311 241.208 108.311 241.018C108.311 240.828 108.159 240.674 107.971 240.674Z"
        fill="#DD0031"
      />
      <path
        d="M108.992 243.785C108.805 243.785 108.653 243.939 108.653 244.129C108.653 244.319 108.805 244.473 108.992 244.473C109.18 244.473 109.332 244.319 109.332 244.129C109.332 243.939 109.18 243.785 108.992 243.785Z"
        fill="#DD0031"
      />
      <path
        d="M111.038 243.785C110.85 243.785 110.698 243.939 110.698 244.129C110.698 244.319 110.85 244.473 111.038 244.473C111.225 244.473 111.377 244.319 111.377 244.129C111.377 243.939 111.225 243.785 111.038 243.785Z"
        fill="#DD0031"
      />
      <path
        d="M110.013 242.749C109.826 242.749 109.674 242.903 109.674 243.093C109.674 243.283 109.826 243.437 110.013 243.437C110.201 243.437 110.353 243.283 110.353 243.093C110.353 242.903 110.201 242.749 110.013 242.749V242.749Z"
        fill="#DD0031"
      />
      <path
        d="M107.971 242.749C107.784 242.749 107.632 242.903 107.632 243.093C107.632 243.283 107.784 243.437 107.971 243.437C108.159 243.437 108.311 243.283 108.311 243.093C108.311 242.903 108.159 242.749 107.971 242.749V242.749Z"
        fill="#DD0031"
      />
      <path
        d="M110.013 244.82C109.826 244.82 109.674 244.975 109.674 245.165C109.674 245.355 109.826 245.509 110.013 245.509C110.201 245.509 110.353 245.355 110.353 245.165C110.353 244.975 110.201 244.82 110.013 244.82Z"
        fill="#DD0031"
      />
      <path
        d="M107.971 244.82C107.784 244.82 107.632 244.975 107.632 245.165C107.632 245.355 107.784 245.509 107.971 245.509C108.159 245.509 108.311 245.355 108.311 245.165C108.311 244.975 108.159 244.82 107.971 244.82Z"
        fill="#DD0031"
      />
      <path
        d="M108.992 241.713C108.805 241.713 108.653 241.867 108.653 242.058C108.653 242.248 108.805 242.402 108.992 242.402C109.18 242.402 109.332 242.248 109.332 242.058C109.332 241.867 109.18 241.713 108.992 241.713Z"
        fill="#DD0031"
      />
      <path
        d="M111.038 241.713C110.85 241.713 110.698 241.867 110.698 242.058C110.698 242.248 110.85 242.402 111.038 242.402C111.225 242.402 111.377 242.248 111.377 242.058C111.377 241.867 111.225 241.713 111.038 241.713Z"
        fill="#DD0031"
      />
      <path
        d="M108.992 247.931C108.805 247.931 108.653 248.085 108.653 248.275C108.653 248.465 108.805 248.619 108.992 248.619C109.18 248.619 109.332 248.465 109.332 248.275C109.332 248.085 109.18 247.931 108.992 247.931Z"
        fill="#DD0031"
      />
      <path
        d="M110.013 246.895C109.826 246.895 109.674 247.049 109.674 247.239C109.674 247.429 109.826 247.583 110.013 247.583C110.201 247.583 110.353 247.429 110.353 247.239C110.353 247.049 110.201 246.895 110.013 246.895Z"
        fill="#DD0031"
      />
      <path
        d="M107.971 246.895C107.784 246.895 107.632 247.049 107.632 247.239C107.632 247.429 107.784 247.583 107.971 247.583C108.159 247.583 108.311 247.429 108.311 247.239C108.311 247.049 108.159 246.895 107.971 246.895Z"
        fill="#DD0031"
      />
      <path
        d="M108.992 245.856C108.805 245.856 108.653 246.01 108.653 246.2C108.653 246.39 108.805 246.544 108.992 246.544C109.18 246.544 109.332 246.39 109.332 246.2C109.332 246.01 109.18 245.856 108.992 245.856Z"
        fill="#DD0031"
      />
      <path
        d="M111.038 245.856C110.85 245.856 110.698 246.01 110.698 246.2C110.698 246.39 110.85 246.544 111.038 246.544C111.225 246.544 111.377 246.39 111.377 246.2C111.377 246.01 111.225 245.856 111.038 245.856Z"
        fill="#DD0031"
      />
      <path
        d="M104.906 239.639C104.718 239.639 104.566 239.793 104.566 239.983C104.566 240.173 104.718 240.327 104.906 240.327C105.093 240.327 105.245 240.173 105.245 239.983C105.245 239.793 105.093 239.639 104.906 239.639Z"
        fill="#DD0031"
      />
      <path
        d="M106.951 239.639C106.763 239.639 106.611 239.793 106.611 239.983C106.611 240.173 106.763 240.327 106.951 240.327C107.138 240.327 107.29 240.173 107.29 239.983C107.29 239.793 107.138 239.639 106.951 239.639Z"
        fill="#DD0031"
      />
      <path
        d="M105.93 238.603C105.743 238.603 105.591 238.757 105.591 238.947C105.591 239.137 105.743 239.291 105.93 239.291C106.117 239.291 106.269 239.137 106.269 238.947C106.269 238.757 106.117 238.603 105.93 238.603V238.603Z"
        fill="#DD0031"
      />
      <path
        d="M105.93 240.674C105.743 240.674 105.591 240.828 105.591 241.018C105.591 241.208 105.743 241.363 105.93 241.363C106.117 241.363 106.269 241.208 106.269 241.018C106.269 240.828 106.117 240.674 105.93 240.674Z"
        fill="#DD0031"
      />
      <path
        d="M103.885 240.674C103.697 240.674 103.546 240.828 103.546 241.018C103.546 241.208 103.697 241.363 103.885 241.363C104.072 241.363 104.224 241.208 104.224 241.018C104.224 240.828 104.072 240.674 103.885 240.674Z"
        fill="#DD0031"
      />
      <path
        d="M104.906 243.785C104.718 243.785 104.566 243.939 104.566 244.129C104.566 244.319 104.718 244.473 104.906 244.473C105.093 244.473 105.245 244.319 105.245 244.129C105.245 243.939 105.093 243.785 104.906 243.785Z"
        fill="#DD0031"
      />
      <path
        d="M106.951 243.785C106.763 243.785 106.611 243.939 106.611 244.129C106.611 244.319 106.763 244.473 106.951 244.473C107.138 244.473 107.29 244.319 107.29 244.129C107.29 243.939 107.138 243.785 106.951 243.785Z"
        fill="#DD0031"
      />
      <path
        d="M105.93 242.749C105.743 242.749 105.591 242.903 105.591 243.093C105.591 243.283 105.743 243.437 105.93 243.437C106.117 243.437 106.269 243.283 106.269 243.093C106.269 242.903 106.117 242.749 105.93 242.749V242.749Z"
        fill="#DD0031"
      />
      <path
        d="M103.885 242.749C103.697 242.749 103.546 242.903 103.546 243.093C103.546 243.283 103.697 243.437 103.885 243.437C104.072 243.437 104.224 243.283 104.224 243.093C104.224 242.903 104.072 242.749 103.885 242.749V242.749Z"
        fill="#DD0031"
      />
      <path
        d="M105.93 244.82C105.743 244.82 105.591 244.975 105.591 245.165C105.591 245.355 105.743 245.509 105.93 245.509C106.117 245.509 106.269 245.355 106.269 245.165C106.269 244.975 106.117 244.82 105.93 244.82Z"
        fill="#DD0031"
      />
      <path
        d="M104.906 241.713C104.718 241.713 104.566 241.867 104.566 242.058C104.566 242.248 104.718 242.402 104.906 242.402C105.093 242.402 105.245 242.248 105.245 242.058C105.245 241.867 105.093 241.713 104.906 241.713Z"
        fill="#DD0031"
      />
      <path
        d="M106.951 241.713C106.763 241.713 106.611 241.867 106.611 242.058C106.611 242.248 106.763 242.402 106.951 242.402C107.138 242.402 107.29 242.248 107.29 242.058C107.29 241.867 107.138 241.713 106.951 241.713Z"
        fill="#DD0031"
      />
      <path
        d="M106.951 245.856C106.763 245.856 106.611 246.01 106.611 246.2C106.611 246.39 106.763 246.544 106.951 246.544C107.138 246.544 107.29 246.39 107.29 246.2C107.29 246.01 107.138 245.856 106.951 245.856Z"
        fill="#DD0031"
      />
      <path
        d="M102.864 239.639C102.677 239.639 102.525 239.793 102.525 239.983C102.525 240.173 102.677 240.327 102.864 240.327C103.051 240.327 103.203 240.173 103.203 239.983C103.203 239.793 103.051 239.639 102.864 239.639Z"
        fill="#DD0031"
      />
      <path
        d="M101.843 240.674C101.656 240.674 101.504 240.828 101.504 241.018C101.504 241.208 101.656 241.363 101.843 241.363C102.03 241.363 102.182 241.208 102.182 241.018C102.182 240.828 102.03 240.674 101.843 240.674Z"
        fill="#DD0031"
      />
      <path
        d="M100.822 243.785C100.635 243.785 100.483 243.939 100.483 244.129C100.483 244.319 100.635 244.473 100.822 244.473C101.009 244.473 101.161 244.319 101.161 244.129C101.161 243.939 101.009 243.785 100.822 243.785Z"
        fill="#DD0031"
      />
      <path
        d="M102.864 243.785C102.677 243.785 102.525 243.939 102.525 244.129C102.525 244.319 102.677 244.473 102.864 244.473C103.051 244.473 103.203 244.319 103.203 244.129C103.203 243.939 103.051 243.785 102.864 243.785Z"
        fill="#DD0031"
      />
      <path
        d="M101.843 242.749C101.656 242.749 101.504 242.903 101.504 243.093C101.504 243.283 101.656 243.437 101.843 243.437C102.03 243.437 102.182 243.283 102.182 243.093C102.182 242.903 102.03 242.749 101.843 242.749V242.749Z"
        fill="#DD0031"
      />
      <path
        d="M100.822 241.713C100.635 241.713 100.483 241.867 100.483 242.058C100.483 242.248 100.635 242.402 100.822 242.402C101.009 242.402 101.161 242.248 101.161 242.058C101.161 241.867 101.009 241.713 100.822 241.713Z"
        fill="#DD0031"
      />
      <path
        d="M102.864 241.713C102.677 241.713 102.525 241.867 102.525 242.058C102.525 242.248 102.677 242.402 102.864 242.402C103.051 242.402 103.203 242.248 103.203 242.058C103.203 241.867 103.051 241.713 102.864 241.713Z"
        fill="#DD0031"
      />
      <rect
        x="82"
        y="226"
        width="44"
        height="44"
        rx="22"
        stroke="#DD0031"
        strokeWidth="4"
      />
      <text
        fill="#DD0031"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="20"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="136" y="255.76">
          Apply
        </tspan>
      </text>
      <text
        fill="#5B6770"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="14"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="136" y="188.032">
          ~13 MONTHS PRE-GRAND OPENING
        </tspan>
      </text>
      <rect x="82" y="134" width="44" height="44" rx="22" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M112.59 146.929L114.606 150.43C114.693 150.593 114.686 150.789 114.588 150.947C114.494 151.105 114.321 151.202 114.135 151.202H113.35V164.847C113.35 165.114 113.132 165.331 112.862 165.333H95.1336C94.862 165.333 94.6419 165.116 94.6419 164.847V151.202H93.8573C93.6712 151.202 93.4989 151.105 93.404 150.947C93.3098 150.787 93.3098 150.589 93.404 150.43L95.4265 146.929C95.5172 146.77 95.6854 146.671 95.8694 146.667H112.137C112.325 146.666 112.498 146.766 112.59 146.929ZM111.833 147.7H96.1762L94.7709 150.157H113.252L113.075 149.851C113.041 149.862 113.006 149.869 112.97 149.871C112.735 149.871 112.543 149.684 112.541 149.451C112.54 149.337 112.587 149.227 112.67 149.148L112.116 148.186C112.132 148.229 112.142 148.275 112.144 148.321C112.144 148.555 111.952 148.745 111.715 148.745C111.478 148.745 111.286 148.555 111.286 148.321C111.286 148.087 111.478 147.897 111.715 147.897C111.838 147.897 111.956 147.952 112.035 148.045L111.833 147.7ZM104.493 164.32V156.687H110.421V164.32H104.493ZM98.122 154.482L97.2154 155.778H110.853L109.95 154.482H98.122ZM97.6408 156.687H103.593V164.32H97.6408V156.687ZM111.31 164.365H112.384V151.202H111.816V151.777C111.816 152.045 111.596 152.263 111.324 152.263C111.053 152.263 110.833 152.045 110.833 151.777V151.202H109.713V151.777C109.713 152.045 109.493 152.263 109.222 152.263C108.95 152.263 108.73 152.045 108.73 151.777V151.202H107.611V151.777C107.626 151.96 107.536 152.136 107.378 152.232C107.22 152.328 107.021 152.328 106.863 152.232C106.705 152.136 106.615 151.96 106.631 151.777V151.202H105.511V151.777C105.511 152.045 105.291 152.263 105.02 152.263C104.748 152.263 104.528 152.045 104.528 151.777V151.202H103.402V151.777C103.417 151.96 103.327 152.136 103.169 152.232C103.011 152.328 102.812 152.328 102.654 152.232C102.496 152.136 102.406 151.96 102.422 151.777V151.202H101.302V151.777C101.302 152.045 101.082 152.263 100.811 152.263C100.539 152.263 100.319 152.045 100.319 151.777V151.202H99.1996V151.777C99.1996 152.045 98.9795 152.263 98.708 152.263C98.4364 152.263 98.2163 152.045 98.2163 151.777V151.202H97.1039V151.777C97.1195 151.96 97.0297 152.136 96.8717 152.232C96.7136 152.328 96.5143 152.328 96.3563 152.232C96.1982 152.136 96.1084 151.96 96.124 151.777V151.202H95.6254V164.365H96.7587V156.66H96.3646C96.1992 156.66 96.0471 156.57 95.9697 156.425C95.8922 156.281 95.9019 156.106 95.995 155.971L97.5189 153.789C97.601 153.669 97.7381 153.597 97.885 153.596H110.184C110.332 153.597 110.47 153.669 110.554 153.789L112.074 155.971C112.167 156.105 112.177 156.28 112.1 156.424C112.024 156.568 111.873 156.659 111.708 156.66H111.289L111.31 164.365Z"
        fill="#DD0031"
      />
      <ellipse
        cx="98.2651"
        cy="149.461"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="99.109"
        cy="155.202"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="101.578"
        cy="155.202"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="104.047"
        cy="155.202"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="106.519"
        cy="155.202"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="108.988"
        cy="155.202"
        rx="0.428912"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="95.7963"
        cy="149.461"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="103.206"
        cy="149.461"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="100.734"
        cy="149.461"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="97.0131"
        cy="148.331"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="101.951"
        cy="148.331"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="99.482"
        cy="148.331"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="105.647"
        cy="149.461"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="110.585"
        cy="149.461"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="108.116"
        cy="149.461"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="104.392"
        cy="148.331"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="109.333"
        cy="148.331"
        rx="0.428912"
        ry="0.423851"
        fill="#DD0031"
      />
      <ellipse
        cx="106.864"
        cy="148.331"
        rx="0.428913"
        ry="0.423851"
        fill="#DD0031"
      />
      <rect
        x="82"
        y="134"
        width="44"
        height="44"
        rx="22"
        stroke="#DD0031"
        strokeWidth="4"
      />
      <text
        fill="#DD0031"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="20"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="136.498" y="161.76">
          Activate
        </tspan>
      </text>
      <text
        fill="#5B6770"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="16"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="5.5" y="196.608">
          {dayjs(recruitPhase1Date).format("MMM DD")}
        </tspan>
      </text>
      <g
        fill={
          dayjs().isSameOrAfter(recruitPhase1Date)
            ? dayjs().isBefore(recruitPhase2Date)
              ? "#DD0031"
              : "#004F71"
            : "#3EB1C8"
        }
      >
        <path
          d="M18 218V208L28 218L38 208V218H28H18Z"
          className="phase-1"
          // fill="#004F71"
        />
        <rect
          width="60"
          height="20"
          transform="translate(38 218) rotate(90)"
          className="phase-1"
          // fill="#004F71"
        />
        <path
          d="M18 278H38L28 288L18 278Z"
          className="phase-1"
          // fill="#004F71"
        />
      </g>
      <text
        fill="#5B6770"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="16"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="4.5" y="308.608">
          {dayjs(recruitPhase2Date).format("MMM DD")}
        </tspan>
      </text>
      <g
        fill={
          dayjs().isSameOrAfter(recruitPhase2Date)
            ? dayjs().isBefore(recruitPhase3Date)
              ? "#DD0031"
              : "#004F71"
            : "#3EB1C8"
        }
      >
        <path
          d="M18 330V320L28 330L38 320V330H28H18Z"
          className="phase-2"
          // fill="#DD0031"
        />
        <rect
          width="20"
          height="20"
          transform="translate(38 330) rotate(90)"
          className="phase-2"
          // fill="#DD0031"
        />
        <path
          d="M18 350H38L28 360L18 350Z"
          className="phase-2"
          // fill="#DD0031"
        />
      </g>
      <text
        fill="#5B6770"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="16"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="2" y="380.608">
          {dayjs(recruitPhase3Date).format("MMM DD")}
        </tspan>
      </text>
      <g
        fill={
          dayjs().isSameOrAfter(recruitPhase3Date)
            ? dayjs().isBefore(recruitPhase5Date)
              ? "#DD0031"
              : "#004F71"
            : "#3EB1C8"
        }
      >
        <path
          d="M18 402V392L28 402L38 392V402H28H18Z"
          className="phase-4"
          //   fill="#3EB1C8"
        />
        <rect
          width="180"
          height="20"
          transform="translate(38 402) rotate(90)"
          className="phase-4"
          //   fill="#3EB1C8"
        />
        <path
          d="M18 582H38L28 592L18 582Z"
          className="phase-4"
          //   fill="#3EB1C8"
        />
      </g>
      <text
        fill="#5B6770"
        xmlSpace="preserve"
        style={{ whiteSpace: "pre" }}
        fontFamily="Apercu"
        fontSize="16"
        fontWeight="bold"
        letterSpacing="0em"
      >
        <tspan x="3.5" y="612.608">
          {dayjs(recruitPhase5Date).format("MMM DD")}
        </tspan>
      </text>
      <path d="M18 634V624L28 634L38 624V634H28H18Z" fill="#A7ACAF" />
      <rect
        width="100"
        height="20"
        transform="translate(38 634) rotate(90)"
        fill="#A7ACAF"
      />
      <path d="M18 734H38L28 744L18 734Z" fill="#A7ACAF" />
      <defs>
        <clipPath id="clip0_2_397">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(92 480)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default MultiRestaurantSelection;
